'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param fn
 * @param deps
 * Example: useCallbackRef(() => callback(obj), [obj, callback])
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var usePersistentCallback = function usePersistentCallback(fn) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = React__default["default"].useRef(fn);
  React__default["default"].useEffect(function () {
    ref.current = fn;
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React__default["default"].useCallback(function () {
    var _ref$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.call.apply(_ref$current, [ref].concat(args));
  }, deps);
};

exports.usePersistentCallback = usePersistentCallback;
//# sourceMappingURL=usePersistentCallback-d464e155.js.map
